import { call, put, takeLeading } from 'redux-saga/effects';
import { SIGNUP_REQUEST } from '../constants';
import { signupSuccess, signupFailure, userAlreadyRegistered } from '../actions/signupAction';
import Toast from '../../utils/commoncomponent/Toast';
import { authAPI, adminAPI } from '../../utils/axiosInstance';
import { trackMetaLead } from '../../utils/metaPixel';

function* signupSaga(action) {
  try {
    const response = yield call([authAPI, 'post'], '/signup', action.payload);
    if (response.data.status === 'USER ALREADY REGISTERED') {
      yield put(userAlreadyRegistered());
      Toast.error('User already exists. Please log in instead.');
      return;
    }

    const { loginId } = response.data;
    const studentData = {
      loginCredential: {
        loginId: loginId,
      },
      userName: action.payload.userName,
      contactDetails: {
        phoneNo: action.payload.phoneNo,
        emailId: action.payload.emailId
      }
    };
    try {
      const secondResponse = yield call([adminAPI, 'post'], '/admin/user', studentData);
      yield put(signupSuccess({ userId: secondResponse.data.userId }));
      if (action.payload.role === "student") {
        trackMetaLead();
      }
      const isResend = secondResponse.data?.status === 'UPDATED';
      Toast.show(
        isResend
          ? 'A new verification code has been sent to your email.'
          : 'Check your email for the 6-digit verification code to activate your account.',
      );
    } catch (secondError) {
      const message = secondError.response?.data?.message || '';
      if (message.toLowerCase().includes('already exist')) {
        yield put(userAlreadyRegistered());
        Toast.error('User already exists. Please log in instead.');
      } else {
        yield put(signupFailure(message || 'Registration Failed, Try Again'));
        Toast.error(message || 'Registration Failed, Try Again');
      }
    }
  } catch (error) {
    console.log("Error from sign saga", error);
    yield put(signupFailure(error.response?.data?.message || 'Registration Failed, Try Again'));
    Toast.error(error.response?.data?.message || 'Registration Failed, Try Again');
  }
}

export function* watchSignup() {
  // Prevent silent cancellation when users trigger submit multiple times.
  yield takeLeading(SIGNUP_REQUEST, signupSaga);
}